import { Injectable } from '@angular/core';
import gql from 'graphql-tag';

import { Direction } from 'infrastructure/common/api.adpater';
import { ApiPageableOutput } from 'infrastructure/common/model/api-pageable.output';
import { ApiQuery } from 'infrastructure/common/model/api.query';
import { TaskStatus } from 'task/model/task.status';
import { TaskType } from 'task/model/task.type';
import { IamUserTaskExportTaskOutput } from 'user/model/iam-user-task-export-task.output';
import { UserTaskExportTaskStatus } from 'user/model/user-task-export-task-status';
import { UserTaskExportTaskSort } from 'user/model/user-task-export-task.sort';
import { user } from 'user/model/user.fragments';

export interface SearchUserTaskExportedTasksParams {
	readonly offset: number;
	readonly userId: string;
	readonly chunkSize: number;
	readonly participantId: string;
	readonly dueEndTimestamp: number;
	readonly sortDirection: Direction;
	readonly dueStartTimestamp: number;
	readonly exportedTasksType: TaskType;
	readonly sortProperty: UserTaskExportTaskSort;
	readonly exportedTaskStatuses: TaskStatus[];
	readonly statuses: UserTaskExportTaskStatus[];
}

@Injectable({ providedIn: 'root' })
export class SearchUserTaskExportTasksApiQuery extends ApiQuery<
	ApiPageableOutput<IamUserTaskExportTaskOutput>,
	SearchUserTaskExportedTasksParams
> {
	client = 'iam';
	document = gql`
		query SearchUserTaskExportTasks(
			$offset: Int
			$userId: UUID!
			$chunkSize: Int
			$participantId: UUID
			$dueEndTimestamp: Long
			$dueStartTimestamp: Long
			$sortDirection: Direction
			$exportedTasksType: TaskType!
			$exportedTaskStatuses: [TaskStatus]
			$sortProperty: UserTaskExportTaskSort
			$statuses: [UserTaskExportTaskStatus]
		) {
			searchUserTaskExportTasks(
				offset: $offset
				userId: $userId
				statuses: $statuses
				chunkSize: $chunkSize
				sortProperty: $sortProperty
				participantId: $participantId
				sortDirection: $sortDirection
				dueEndTimestamp: $dueEndTimestamp
				dueStartTimestamp: $dueStartTimestamp
				exportedTasksType: $exportedTasksType
				exportedTaskStatuses: $exportedTaskStatuses
			) {
				elements {
					id
					status
					dueTimestamp
					updateTimestamp
					creationTimestamp
					exportedTasksType
					exportedTaskStatuses
					exportedTasksDocumentUrl
					exportedTasksParticipant {
						...User
					}
					user {
						...User
					}
				}
			}
		}
		${user}
	`;
	method = 'searchUserTaskExportTasks';
}
